import { useEffect } from 'react';

export function useTouchScrollLock(active: boolean) {
  useEffect(() => {
    if (!active) {
      return;
    }

    const originalTouchAction = document.body.style.touchAction;
    document.body.style.touchAction = 'none';

    const preventScroll = (e: TouchEvent) => {
      e.preventDefault();
    };

    document.addEventListener('touchmove', preventScroll, { passive: false });

    return () => {
      document.body.style.touchAction = originalTouchAction;
      document.removeEventListener('touchmove', preventScroll);
    };
  }, [active]);
}
